<template>
  <div>
    <b-row>
      <b-col sm="6" md="6" lg="4">
        <b-form-group
          label="Filtr"
          label-cols-md="2"
          label-align-md="right"
          label-size="md"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group>
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="szukany text..."
              @input="onFilterChange"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Wyczyść</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col sm="6" md="6" lg="5">
        <b-form-group
          label="Filtruj po polach"
          label-cols-md="3"
          label-align-sm="right"
          label-size="md"
          class="mb-0">
          <b-form-checkbox-group v-model="filterOn" class="mt-2">
            <b-form-checkbox value="title">Tytuł</b-form-checkbox>
            <b-form-checkbox value="place">Miejsce</b-form-checkbox>
            <b-form-checkbox value="categories">Kategoria</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col cols="4">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="events-table"
          align="fill"
          size="md"
          first-text="⏮"
          prev-text="⏪"
          next-text="⏩"
          last-text="⏭"
        ></b-pagination>
      </b-col>

      <b-col cols='4'>
        <b-button-group>
          <b-button variant='primary' size='sm' @click='onSelectAll'>Zaznacz wszystkie</b-button>
          <b-button variant='success' size='sm' @click='onDeSelectAll'>Odznacz wszystkie</b-button>
        </b-button-group>
      </b-col>

      <b-col cols="4">
        <b-form-group class="float-right mr-2">
          <b-form-select
              v-model="perPage"
              id="perPageSelect"
              :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-table
      id='events-table'
      sticky-header
      small
      striped
      primary-key="id"
      :items="filteredEvents"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      sort-icon-left
      @row-clicked="rowClicked"
    >
      <template v-slot:cell(selected)="{ item, field: { key } }" >
        <b-checkbox v-model="item[key]"></b-checkbox>
      </template>
    </b-table>
    <p v-if="selectedEventsIds.length > 0" class="border border-light rounded p-2 mb-0">
      <span>Zaznaczono ({{selectedEventsIds.length}}):</span>
      <span class='badge badge-success font-weight-bold text-wrap ml-2 text-white mt-1 mb-1'
        style='font-size: 14px;'
        v-for='t in selectedEventsIds'
        :key='t.id'
      >
        {{t}}
      </span>
    </p> 
  </div>
</template>

<script>
import { sendRequest, tokenRefresh } from "@/api"

export default {
  props: ['eventsIds'],
  data() {
    return {
      events: [],
      fields: [
        {
          key: 'selected',
          label: 'Zaznacz',
          sortable: true,
          thStyle: { width: '80px' },
        },
        {
          key: 'id',
          label: 'ID',
          sortable: true,
          thStyle: { width: '100px' },
        },
        {
          key: 'title',
          label: 'Tytuł',
          sortable: true,
          thStyle: { width: '500px' },
        },
        {
          key: 'starts_at',
          label: 'Start eventu',
          sortable: true,
          thStyle: { width: '150px' },
          formatter: value => this.$moment(value).format('YYYY-MM-DD HH:mm')
        },
        {
          key: 'ends_at',
          label: 'Koniec eventu',
          sortable: true,
          thStyle: { width: '150px' },
          formatter: value => this.$moment(value).format('YYYY-MM-DD HH:mm')
        },
        {
          key: 'place',
          label: 'Miejsce',
          sortable: true,
          thStyle: { width: '200px' },
        },
        {
          key: 'categories',
          label: 'Kategoria',
          sortable: true,
        },
        {
          key: 'db_created',
          label: 'Dodano',
          sortable: true,
          thStyle: { width: '150px' },
          formatter: value => this.$moment(value).format('YYYY-MM-DD HH:mm')
        }
      ],
      perPage: 50,
      pageOptions: [5, 10, 15, 25, 50, 100],
      currentPage: 1,
      filter: '',
      filterOn: [],
      totalRows: 0,
    }
  },
  mounted() {
    this.loadEvents()
  },
  methods: {
    setEventsSelected(selected){
      this.events.map(event => {
        this.$set(event, 'selected', this.found(event) ? selected : event.selected)
      })
      this.emitSelectedEvents()
    },
    onSelectAll() {
      this.setEventsSelected(true)
    },
    onDeSelectAll() {
      this.setEventsSelected(false)
    },
    onFilterChange(filter) {
      this.filter = filter
    },
    addSelectedFieldToEvent() {
      let eventsIds = this.eventsIds ? this.eventsIds.split(',').map(id => parseInt(id.trim())) : []
      this.events.map(event => {
        this.$set(event, 'selected', eventsIds.includes(event.id))
      })
    },
    emitSelectedEvents() {
      console.log('emitSelectedEvents', this.selectedEventsIds)
      this.$emit('select:events', {selectedEvents: this.selectedEventsIds.join(', ')})
    },
    rowClicked(item) {
      this.$set(item, 'selected', !item.selected)
      this.emitSelectedEvents()
    },
    async loadEvents() {
      const year = this.$moment().get('year')
      const token = localStorage.getItem("token")
      const startDate = this.$moment(`${year - 1}-01-01`).format('YYYY-MM-DD')
      await tokenRefresh()
      const { data } = await sendRequest(
        "get",
        `api/events/from_range/?start_date='${startDate}'`
      )
      this.events = data.data
      this.totalRows = data.data.length
      this.addSelectedFieldToEvent()
    },
    foundBy(fieldName, event) {
      if (this.filterOn.length > 0 && !this.filterOn.includes(fieldName)) 
        return false  

      let value = event[fieldName].toUpperCase()
      let filter = this.filter.toUpperCase()
      for (let word of filter.split(' ')) {
        if (value.indexOf(word) === -1)
          return false
      }
      return true
    },
    found(event) {
      return (
        this.foundBy('title', event) ||
        this.foundBy('place', event) ||
        this.foundBy('categories', event)
      )
    },
  },  
  computed: {
    filteredEvents() {
      if (this.filter == '') {
        return this.events  
      }
      let events = []
      events = this.events.filter(event => this.found(event))
      return events
    },
    selectedEventsIds() {
      return this.events.filter(event => event.selected).map(event => event.id)
    },
  }
}
</script>